import { Divider, Switch, Tag } from 'antd'
import React, { Dispatch, FC, ReactNode, SetStateAction } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
`

const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`

const PropagateContainer = styled.div`
  display: flex;
  align-items: center;
`

const Label = styled.span`
  margin-right: 8px;
`

export const ActiveFilterSection: FC<{
  columnFilterValues: ReadonlyMap<string, string>
  columnFilterKeyToLabel: ReadonlyMap<string, ReactNode>
  propagateColumnFilters: boolean
  setPropagateColumnFilters: Dispatch<SetStateAction<boolean>>
  rowFilterIds?: ReadonlyArray<string>
}> = ({
  columnFilterValues,
  columnFilterKeyToLabel,
  propagateColumnFilters,
  setPropagateColumnFilters,
  rowFilterIds,
}) => {
  const hasColumnFilters = columnFilterValues.size > 0
  const hasRowFilters = rowFilterIds && rowFilterIds.length > 0

  return (
    (hasColumnFilters || hasRowFilters) && (
      <>
        <Divider type='horizontal' />
        {hasRowFilters && (
          <Container>
            <TagsContainer>
              Selected Rows:
              {rowFilterIds.map((id) => (
                <Tag key={id}>{id}</Tag>
              ))}
            </TagsContainer>
          </Container>
        )}
        {hasColumnFilters && (
          <Container>
            <TagsContainer>
              Column Searches:
              {Array.from(columnFilterValues.entries()).map(([key, value]) => (
                <Tag key={key}>
                  {columnFilterKeyToLabel.get(key) || key}: {value}
                </Tag>
              ))}
            </TagsContainer>
            <PropagateContainer>
              <Label>Apply column searches as filters:</Label>
              <Switch
                checked={propagateColumnFilters}
                onChange={setPropagateColumnFilters}
              />
            </PropagateContainer>
          </Container>
        )}
      </>
    )
  )
}
